import { withTypography } from 'ucl/components/text/Typography';

import { SectionHeading } from 'pages/support-v2/support-form-v2.styled';

export const RecentOrdersDescriptionText = withTypography({ style: { marginBottom: 8 } });

export const HeadingStyled = SectionHeading.withConfig({
  lineHeight: '32px',
});
